import React, {useState} from "react";
import IconButton from '@mui/material/IconButton';
import TrafficlightButtonRed from "../../../../../../../components/Button/TrafficlightButtonRed";
import CustomDialog from "../../../../../../../components/Dialog/DiaComp";
import { TextSignal } from "./TextSignal";


export default function Dia_FTO_Signal() {

const [open, setOpen] = useState(false);
const handleOpen = () => {setOpen(true);};
const handleClose = () => {setOpen(false);};

return(
<>      

<IconButton onClick={handleOpen} sx={{fontSize: '180%'}}>
    <TrafficlightButtonRed  />
</IconButton>

<CustomDialog open={open} onClose={handleClose}

    title='FTO Gene - Analysis'

    content={ <TextSignal />}

/>

</>
)}